module.exports = __webpack_public_path__ + "img/inset.1bf1a084.png";